'use strict';

angular.module('cvsApp').service('configservice', ['$log','$location','PageValues',function ($log,location,PageValues) {

// Set Default Environment to be Selected in case no valid param is passed in URL and the host is not recognized
    var defaultEnv = PageValues.defaultEnv;
    var sitURL='';
    
    var _envs = PageValues.envs,
        appConfigs = PageValues.appConfigs,
        _env;


    this.getEnv = function () {
        var envParam = getQueryStringValue('env');
        if (getQueryStringValue('env') === '') {
            var host = window.location.host;
            for (var env in _envs) {
                if (host.indexOf(env) > -1 || (typeof _envs[env].host === "string" && _envs[env].host == host) || (typeof _envs[env].host === "string" && _envs[env].host.contains(host)) || (typeof _envs[env].host === "object" && _envs[env].host.indexOf(host) > -1)) {
                    _env = env;
                    return _env;
                } // if
            } //for
            return defaultEnv;
        } else {
            var _env = _envs[envParam];
            if (envParam != undefined)
                return envParam;
            else
                return defaultEnv;
        }

        // Private Utility Function
        function getQueryStringValue(key) {
            var env= cvsUtility.queryMap.env;
            if(env){
                return env === 'www' ? env : env.replace('www','').replace('fast', '');
            }else{
                return unescape(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + escape(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            }
        }
    };

    this.getRedirectUrl = function () {
        var redirectUrl = window.location.protocol + '//' + window.location.host;
        //$log.log("protocol::" + window.location.protocal + "::host::" + window.location.host);
        if (redirectUrl.indexOf('localhost') >= 0) {
            redirectUrl = '';
        }

        return redirectUrl;
    };

    this.appConfig = function () {
            return appConfigs[this.getEnv()];
        }; //get
}]);